export default __webpack_public_path__ + "static/media/authentication_fsn5.085fd381.svg";